(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('main-product:not([data-pdp-enhancements])').forEach((mainProduct) => {
        mainProduct.dataset.pdpEnhancements = 'true';

        mainProduct.querySelectorAll('.simple-carousel__image').forEach((slide) => {
            slide.addEventListener('pointermove', (event) => {
                const bounds = slide.getBoundingClientRect();
                const x = ((event.clientX - bounds.left) / bounds.width) * 100;
                const y = ((event.clientY - bounds.top) / bounds.height) * 100;
                slide.style.setProperty('--zoom-x', `${x}%`);
                slide.style.setProperty('--zoom-y', `${y}%`);
            });
            slide.addEventListener('pointerleave', () => {
                slide.style.removeProperty('--zoom-x');
                slide.style.removeProperty('--zoom-y');
            });
        });

        const stickyCart = mainProduct.querySelector('[data-sticky-product-cart]');
        const stickyButton = mainProduct.querySelector('[data-sticky-product-button]');
        const originalButton = mainProduct.querySelector('[data-main-product-buy-button]');
        const productInfo = mainProduct.querySelector('.product-info');

        if (!stickyCart || !stickyButton || !originalButton || !productInfo) return;

        const syncStickyCart = () => {
            const price = mainProduct.querySelector('.purchase-option__button.active .purchase-option__price strong, .single_buy.active [data-main-product-price], [data-main-product-price]');
            const compare = mainProduct.querySelector('.purchase-option__button.active .purchase-option__price s, .signature_buy.active .plan-price__compare, .single_buy.active .plan-price__compare, [data-main-product-compare-at-price]');
            const variantItem = mainProduct.querySelector('.purchase-option__button.active')?.closest('.variant-item');
            const image = mainProduct.querySelector('[data-sticky-product-image]');
            const stickyPrice = mainProduct.querySelector('[data-sticky-product-price]');
            const stickyCompare = mainProduct.querySelector('[data-sticky-product-compare]');
            const stickyTitle = mainProduct.querySelector('[data-sticky-product-title]');
            const selectedPurchaseOption = mainProduct.querySelector('.purchase-option__button.active');
            const addText = window.matchMedia('(max-width: 767px)').matches
                ? stickyButton.dataset.stickyAddText
                : stickyButton.dataset.stickyAddDesktopText;

            stickyButton.disabled = originalButton.disabled;
            stickyButton.textContent = originalButton.disabled ? originalButton.textContent.trim() : addText;
            if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
            if (stickyCompare) stickyCompare.textContent = compare?.textContent.trim() || '';
            if (stickyTitle) {
                const productTitle = stickyTitle.dataset.productTitle;
                const variantTitle = selectedPurchaseOption?.dataset.variantTitle;
                stickyTitle.textContent = variantTitle ? `${variantTitle} — ${productTitle}` : productTitle;
            }
            if (variantItem?.dataset.image && image) image.src = variantItem.dataset.image;
        };

        const updateVisibility = () => {
            const buttonPassed = originalButton.getBoundingClientRect().bottom < 0;
            stickyCart.classList.toggle('is-visible', buttonPassed);
            stickyCart.setAttribute('aria-hidden', String(!buttonPassed));
        };

        stickyButton.addEventListener('click', () => originalButton.click());
        window.addEventListener('scroll', updateVisibility, { passive: true });
        window.addEventListener('resize', syncStickyCart, { passive: true });
        new MutationObserver(syncStickyCart).observe(productInfo, {
            attributes: true,
            childList: true,
            subtree: true
        });

        syncStickyCart();
        updateVisibility();
    });

  } catch(e) { console.error(e); }
})();
})();
